import "./salebanner.scss";

// Sticky bottom banner (owner request 2026-11-03): free trial only.
// The $20 paid trial was removed from the site entirely.
const TRIAL_ANCHOR = "https://skytkd.us/#trial";

export default function SaleBanner() {
  return (
    <div className="sale-banner">
      <p className="sale-banner-text">
        🎉 25th Anniversary — <strong>Try 1 Class FREE</strong>
        <span className="sale-banner-sub">
          {" "}
          · No card needed · FREE uniform when you sign up after your
          trial
        </span>
      </p>
      <div className="sale-banner-actions">
        <a className="sale-banner-cta" href={TRIAL_ANCHOR}>
          Book My FREE Class
        </a>
      </div>
    </div>
  );
}
